<template>
  <div style="margin: 10px 40px 0px">
    <div style="height: 40px;width: 100%;">
      <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
        <span>{{item.name}}</span>
      </div>
      <div class="add-open-btn" @click="addOpen()">
        <strong>+</strong>
      </div>
    </div>
    <div v-if="indexActive === 0">
      <org-fm-info ref="fm" :fmObj="fmObj" @getFather="getFather"></org-fm-info>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import orgFmInfo from './orgFmInfo'
export default {
  name: 'orgListSet',
  model: {
    prop: 'listShow',
    event: 'change'
  },
  props: {
    listObj: {
      type: Object,
      default: null
    }
  },
  components: {orgFmInfo},
  data () {
    return {
      tabs: [
        {index: 0, name: '居家设备FM频率'}
      ],
      indexActive: 0,
      fmObj: {
        type: 'org',
        orgRow: ''
      },
      addEditForm: {
        zonetopic: '', // string 组织topic
        device_type: '',
        fmid: [],
        oid: ''
      }
    }
  },
  created () {
    this.fmObj.orgRow = this.listObj.orgRow
  },
  methods: {
    selectTab (item) {
      this.indexActive = item.index
    },
    addOpen () {
      if (this.indexActive === 0) {
        this.$refs.fm.addShow()
      }
    },
    getFather (obj) {
      if (obj.type === 'close') {
        this.$emit('change', false)
      }
    },
    closeOpen () {
      this.$emit('change', false)
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/orgComponents/orgListSet.vue